<div class="challenge-added-container main-section">
  <div class="l-img accepted"></div>
  <div class="heading">{{ 'store.invitation.created' | translate }}</div>
  <div class="footer-info-text">
    {{ 'store.invitation.createdHint' | translate }}
  </div>
  <div>
    <button (click)="goToStore()" class="btn btn-primary">{{ 'store.invitation.enterStore' | translate }}</button>
  </div>
</div>
